import { useActionState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import FormBody from "../../../../components/form-body";
import Label from "../../../../components/label";
import FormActions from "../../../../components/form-actions";
import { Button } from "../../../../components/button";
import Editor from "../../../../components/editor";
import { TermsAndConditions } from "../../../../models";
import { saveTermsAndConditions, State } from "../actions";

export default function TermsAndConditionsForm({
  termsAndConditions,
}: {
  termsAndConditions: TermsAndConditions | null;
}) {
  const navigate = useNavigate();
  const initialState: State = {
    message: "",
    success: false,
    defaultValues: {
      content: termsAndConditions?.content ?? "",
    },
  };

  const [state, formAction, isPending] = useActionState(
    saveTermsAndConditions,
    initialState
  );

  useEffect(() => {
    if (state?.success) {
      navigate(`/admin/terms-and-conditions?reload=${Date.now()}`);
    }
  }, [state, navigate]);

  return (
    <form className="w-full max-w-3xl text-left py-6" action={formAction}>
      <FormBody>
        {termsAndConditions?.updatedAt ? (
          <p className="mb-4 text-sm text-gray-500">
            Last updated: {new Date(termsAndConditions.updatedAt).toLocaleString()}
          </p>
        ) : null}
        <div>
        
          <Editor
            name="content"
            defaultValue={state.defaultValues.content}
            placeholders={[]}
          />
        </div>
        {state.message && !state.success ? (
          <p className="mt-3 text-sm text-red-600">{state.message}</p>
        ) : null}
        <FormActions>
          <Button
            type="submit"
            disabled={isPending}
            className="min-w-[90px]"
            loading={isPending}
          >
            Save
          </Button>
        </FormActions>
      </FormBody>
    </form>
  );
}
